import React, { useContext } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { toggleSourceVolume } from "store/actions";
import { SPopupContext } from "App/common/hoc/SlidingPopup";
import { objectToArray, formatBytes } from "utils";
import { CONTENT } from "consts";

function Volumes(props) {
  const volumes = props.volumes.list[props.deviceId].volume;
  const { sPopupMethods } = useContext(SPopupContext);

  function clickHandler(e, volVal) {
    e.stopPropagation();
    e.preventDefault();
    volVal.bootable && volVal.checked
      ? sPopupMethods.openPopup("uncheckBootableVolume", {
          execute: () => {
            props.toggleSourceVolume(props.deviceId, volVal.label);
            sPopupMethods.closePopup();
          }
        })
      : props.toggleSourceVolume(props.deviceId, volVal.label);
  }

  return (
    <div className="source_info_item__footer">
      {objectToArray(volumes, { 1: "label" }).map((volVal, volI) => (
        <div
          className="siif_item siif_item_1"
          key={volI}
          onClick={e => clickHandler(e, volVal)}
        >
          <div className="checkbox_wrapper">
            <div className="check">
              <input
                type="checkbox"
                className={
                  "input_checkbox" +
                  (volVal.checked && window.browserName === "ie"
                    ? " ie_checked"
                    : "")
                }
                id={"source_wrapper_item_" + props.driveI + volI}
                defaultChecked={volVal.checked}
              />
              <label htmlFor={"source_wrapper_item_" + props.driveI + volI} />
            </div>
          </div>
          <div className="siif_item_info">
            <p>
              {(volVal.name ? volVal.name : CONTENT.restore.image.volumesList) +
                " (" +
                volVal.label +
                ":)"}
            </p>
            <div className="pc_storage">
              <span
                className="pc_fill"
                style={{
                  width: (volVal.usedSpace / volVal.totalSpace) * 100 + "%"
                }}
              />
            </div>
            <div className="pc_storage_data">
              <p>
                {formatBytes(volVal.usedSpace)} of{" "}
                {formatBytes(volVal.totalSpace)} Used
              </p>
              <p>{volVal.filesystemType}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

function mapStateToProps(state) {
  return {
    volumes: state.backupSettings.volumes
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      toggleSourceVolume
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Volumes);
